import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard CRM
import DashboardReducer from "./trade/reducer";

// User
import UserReducer from "./user/reducer";

// Token
import TokenReducer from "./token/reducer";

// Wallet
import WalletReducer from "./wallet/reducer";


// Pool
import PoolReducer from "./pool/reducer";

// Role
import RoleReducer from "./role/reducer";

// Global
import GlobalReducer from "./global/reducer";

// Configuration
import ConfigurationReducer from "./configuration/reducer";

// Statistic
import StatisticReducer from "./statistic/reducer";

// Setting
import SettingReducer from "./setting/reducer";

// Monitoring
import MonitoringReducer from "./monitoring/reducer";


// Campaign
import CampaignReducer from "./campaign/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  User: UserReducer,
  Role: RoleReducer,
  Global: GlobalReducer,
  Configuration: ConfigurationReducer,
  Statistic: StatisticReducer,
  Setting: SettingReducer,
  Token: TokenReducer,
  Wallet: WalletReducer,
  Pool: PoolReducer,
  Monitoring: MonitoringReducer,
  Campaign: CampaignReducer,
});

export default rootReducer;
